import { saveAs } from 'file-saver';

import { AISearchHistoryEntry } from './aiSearchHistory';
import { buildAISearchHistoryCsv } from './aiSearchHistoryCsv';

export const exportAISearchHistoryCsv = (entries: AISearchHistoryEntry[]): Promise<void> => {
  saveAs(new Blob([buildAISearchHistoryCsv(entries)], { type: 'text/csv;charset=utf-8;' }),
    `ai-search-history-${new Date().toISOString().slice(0, 10)}.csv`);
  return Promise.resolve();
};
